import * as React from 'react'
import { Limit } from '../../components'
import { Block } from 'baseui/block';
import { Input } from "baseui/input";
import {
    LabelLarge,
    LabelMedium,
} from 'baseui/typography';



import { IPID } from './types'

// api
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormattedMessage } from 'react-intl';

export const ConfigurationPanel = (props: IPID) => {

    const [p, setP, setPResult] = useSetObjectValue(props.id, props.resourceGroupId, "p", props.p);
    const onPChanged = (e: any) => setP(parseFloat(e.target.value));

    const [i, setI, setIResult] = useSetObjectValue(props.id, props.resourceGroupId, "i", props.i);
    const onIChanged = (e: any) => setI(parseFloat(e.target.value));

    const [d, setD, setDResult] = useSetObjectValue(props.id, props.resourceGroupId, "d", props.d);
    const onDChanged = (e: any) => setD(parseFloat(e.target.value));

    const [yMin, setYMin, setYMinResult] = useSetObjectValue(props.id, props.resourceGroupId, "yMin", props.yMin);
    const onYMinChanged = (e: any) => setYMin(parseFloat(e.target.value));

    const [yMax, setYMax, setYMaxResult] = useSetObjectValue(props.id, props.resourceGroupId, "yMax", props.yMax);
    const onYMaxChanged = (e: any) => setYMax(parseFloat(e.target.value));

    const [iMin, setIMin, setIMinResult] = useSetObjectValue(props.id, props.resourceGroupId, "iMin", props.iMin);
    const onIMinChanged = (e: any) => setIMin(parseFloat(e.target.value));

    const [iMax, setIMax, setIMaxResult] = useSetObjectValue(props.id, props.resourceGroupId, "iMax", props.iMax);
    const onIMaxChanged = (e: any) => setIMax(parseFloat(e.target.value));


    return (
        <>
            <Block gridRowGap='20px' display='flex' flexDirection='column' >
                <LabelLarge>P</LabelLarge>
                <Input
                    value={p}
                    onChange={onPChanged}
                    disabled={setPResult.isLoading}
                    error={setPResult.isError}
                    endEnhancer={props.pDimension}
                    type='number'
                />
                <LabelLarge>I</LabelLarge>
                <Input
                    value={i}
                    onChange={onIChanged}
                    disabled={setIResult.isLoading}
                    error={setIResult.isError}
                    endEnhancer={props.iDimension}
                    type='number'
                />
                <LabelLarge>D</LabelLarge>
                <Input
                    value={d}
                    onChange={onDChanged}
                    disabled={setDResult.isLoading}
                    error={setDResult.isError}
                    endEnhancer={props.dDimension}
                    type='number'
                />
                <LabelLarge><FormattedMessage id="PID.YMin" defaultMessage="Y Min" /></LabelLarge>
                <Input
                    value={yMin}
                    onChange={onYMinChanged}
                    type='number'
                    disabled={setYMinResult.isLoading}
                    error={setYMinResult.isError}
                    endEnhancer={props.yDimension}
                />
                <LabelLarge><FormattedMessage id="PID.YMax" defaultMessage="Y Max" /></LabelLarge>
                <Input
                    value={yMax}
                    onChange={onYMaxChanged}
                    type='number'
                    disabled={setYMaxResult.isLoading}
                    error={setYMaxResult.isError}
                    endEnhancer={props.yDimension}
                />
                <LabelLarge><LabelLarge><FormattedMessage id="PID.IMin" defaultMessage="I Min" /></LabelLarge></LabelLarge>
                <Input
                    value={iMin}
                    onChange={onIMinChanged}
                    type='number'
                    disabled={setIMinResult.isLoading}
                    error={setIMinResult.isError}
                />
                <LabelLarge><FormattedMessage id="PID.IMax" defaultMessage="I Max" /></LabelLarge>
                <Input
                    value={iMax}
                    onChange={onIMaxChanged}
                    type='number'
                    disabled={setIMaxResult.isLoading}
                    error={setIMaxResult.isError}
                />
            </Block>
        </>
    )
}
